import instance from "../components/general/AxiosInterceptor";
const controller = "/api/user";

export const getCurrentUser = async () => {
  const response = await instance.get(`${controller}/connected`); 
  return response.data?.body;
};

export const changePasswordApi = async (payload) => {
  const response = await instance.put(`${controller}/change-password`, payload);
  return response.data;
};